import React from 'react';
import { IProps as ISideMenuProps } from 'Common/Menu/SideMenu';
import List from 'Common/List';
import ExpandableListItem from 'Common/List/ExpandableListItem';
import ListItem from 'Common/List/ListItem';
import Divider from 'Common/Divider';
import SideMenu from 'Common/Menu/SideMenu';

interface IProps extends ISideMenuProps{

}

const AppSideMenu = ({ open, onClose }: IProps) => {

    const handleSubsystemSelection = (link: string) => {
        window.open(link);
        if (onClose) {
            onClose();
        }
    }

    let location = window.location;

    return (
        <SideMenu
            open={open}
            anchor='left'
            onClose={onClose}
        >
            <List>
                <ListItem button
                    label={"Map"}
                    onClick={() => handleSubsystemSelection("map")}
                    disabled={location.href.includes("map")}
                />
                <ExpandableListItem button label={"CCTV"}>
                    <ListItem button
                        label={"Status"}
                        onClick={() => handleSubsystemSelection("cctv/status")}
                        disabled={location.href.includes("cctv/status")}
                    />
                </ExpandableListItem>
                <Divider />
                <ExpandableListItem button label={"DMS"} >
                    <ListItem button
                        label={"Status"}
                        onClick={() => handleSubsystemSelection("dms/status")}
                        disabled={location.href.includes("dms/status")}
                    />
                </ExpandableListItem>
                <Divider />
                <ExpandableListItem button label={"Scheduling"} >
                    <ListItem button
                        label={"Overview"}
                        onClick={() => handleSubsystemSelection("sas/overview")}
                        disabled={location.href.includes("sas/overview")}
                    />
                    <ListItem button
                        label={"DMS Messages"}
                        onClick={() => handleSubsystemSelection("dms/schedule")}
                        disabled={location.href.includes("dms/schedule")}
                    />
                </ExpandableListItem>
            </List>
        </SideMenu>
    )
}

export default AppSideMenu;